<template>
  <div class="flex justify-start items-center">
    <div :class="[type]" class="w-[6px] h-[6px] mr-[5px] rounded-full"></div>
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
  import { defineProps } from 'vue';

  defineProps({
    type: {
      type: String,
      default: 'primary',
    },
  });
</script>

<style scoped lang="less">
  .primary {
    background-color: rgb(var(--arcoblue-6));
  }
  .success {
    background-color: rgb(var(--green-6));
  }
  .warning {
    background-color: rgb(var(--orange-6));
  }
  .danger {
    background-color: rgb(var(--red-6));
  }
  .info {
    background-color: rgb(var(--arcoblue-6));
  }
</style>
